import { typography } from 'theme/typography'

import { commonStyles } from 'styles/common.styles'

export const styles = {
	container: {
		display: 'flex',
		alignItems: 'center',
		gap: '0.5rem',
	},
	title: {
		...typography.overline,
		...commonStyles.header,
	},
}
